export const VirtualBrandMode = {
  ADD: 1,
  EDIT: 2,
  VIEW: 3,
  SHARED: 4,
};
